import { getSocialProviderText } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
export var extractMessage = function(param, strictLocalize) {
    var provider = param.provider, code = param.code, details = param.details;
    var providerName = getSocialProviderText(provider);
    switch(code){
        case "idpiframe_initialization_failed":
            return strictLocalize({
                id: "W324GB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Please make sure cookies are enabled in your browser window and refresh page."
                    }
                ]
            });
        case "popup_closed_by_user":
            return providerName ? strictLocalize({
                id: "uZf0Sq",
                defaultMessage: [
                    {
                        type: 1,
                        value: "providerName"
                    },
                    {
                        type: 0,
                        value: " authorization failed, please try again."
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                providerName: providerName
            })) : strictLocalize({
                id: "jv6bzR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Authorization failed, please try again."
                    }
                ]
            });
        case "access_denied":
            return strictLocalize({
                id: "kH3s5J",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Access to name and email address is required, please try again."
                    }
                ]
            });
        case "immediate_failed":
            return defaultSSOErrorMessage(strictLocalize);
        default:
            return details !== null && details !== void 0 ? details : defaultSSOErrorMessage(strictLocalize);
    }
};
export var defaultSSOErrorMessage = function(strictLocalize) {
    return strictLocalize({
        id: "ZIOGNP",
        defaultMessage: [
            {
                type: 0,
                value: "An error occurred, please try again."
            }
        ]
    });
};
